// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__UZjxu","avatarImage":"styles_avatarImage__mU5e6"};